import { useParams } from "react-router-dom";
import { useState } from "react";
import SearchBar from "@/components/SearchBar.js";
import GenericBanner from "@/components/GenericBanner";
import Footer from "@/layout/Footer";
import { capitalizeFirstLetter } from "@/utils/StringUtils";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "@/components/Card";
import { Navigation, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import React from "react";
const TrendDetails = () => {
	const { trendId } = useParams();
	const [open, setOpen] = useState(false);

	const sortOptions = [
		"Featured",
		"Price: Low to High",
		"Price: High to Low",
		"Newest Arrivals",
		"Best Sellers",
	];
	const trendDetailsCards = [
		{
			id: 1,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/trend-details/card2.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 3,
			image: "/assets/trend-details/card3.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 4,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
	];
	const trendDetailsCardsRow2 = [
		{
			id: 1,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 3,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 4,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
	];
	const trendDetailsCardsRow3 = [
		{
			id: 1,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 3,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 4,
			image: "/assets/trend-details/card1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
	];

	const colorClassMap = {
		Facebook: "bg-[#0866FF63]",
		Instagram: "bg-[#FA4768]",
		Google: "bg-[#E5E5E5]",
	};
	const bgColorClass =
		colorClassMap[capitalizeFirstLetter(trendId)] || "bg-[#D2DCD1]";
	const colorTextTitleClassMap = {
		Facebook: "text-[#0866FF]",
		Instagram: "text-[#FA4768]",
		Google: "text-[#5F6368]",
	};
	const textColorClass =
		colorTextTitleClassMap[capitalizeFirstLetter(trendId)] || "text-[#193D34]";

	const trendCardOne = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};

	const trendCardTwo = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};

	const trendCardThree = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};

	const trendCardFour = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};
	return (
		<>
			<SearchBar />
			<div className="flex flex-col gap-[30px]">
				<GenericBanner
					iconSrc={`/assets/trend/xl/${trendId}.svg`}
					iconSize={{ width: "w-[160px]", height: "h-[48px]" }}
					title={``}
					subtitle=""
					description={[]}
					bgColor={bgColorClass}
					marginTop=""
					width="w-full"
				/>
				<div className="flex flex-col  w-full xl:w-[90%] mx-auto h-auto   gap-[21px] hidden my-[20px] lg:flex">
					<div className="w-[948px] pr-[16px] pb-[16px] pl-[16px] gap-[8px] flex flex-col">
						<p
							className={`font-[Montserrat] font-semibold text-[32px] leading-[32px] ${textColorClass}`}
						>
							{capitalizeFirstLetter(trendId)} Marketplace
						</p>
						<p className="font-[Montserrat] font-normal text-[14px] leading-[14px] text-[#7A7A7A]">
							+10,000 products listed
						</p>
						<p className="font-[Montserrat] font-normal text-[14px] leading-[14px] text-[#7A7A7A] whitespace-pre-line">
							Leverage Facebook’s vast audience and sell products by sourcing
							from more than 1 billion listings
							<br /> through our{" "}
							<strong>
								Top Automation Software for Facebook Marketplace Dropshipping.
							</strong>
						</p>
					</div>

					<div className="flex items-center justify-between w-full">
						{/* Breadcrumbs - now in one line */}
						<div className="flex items-center gap-[4px]">
							<div className="h-[20px] flex items-center justify-between px-1">
								<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
									Trends
								</span>
								{/* Icon */}
								<img
									src="/assets/search/Icons/bread_crum_arrow.svg"
									alt="Electronic"
									className="w-[10px] h-[10px] ml-1"
								/>
							</div>
							<div className="h-[20px] flex items-center justify-between px-1">
								<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
									{`${capitalizeFirstLetter(trendId)}`}
								</span>
								<img
									src="/assets/search/Icons/bread_crum_arrow.svg"
									alt="Gadgets"
									className="w-[10px] h-[10px] ml-1"
								/>
							</div>
							<div className="h-[20px] flex items-center justify-between px-1">
								<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
									Home
								</span>
								<img
									src="/assets/search/Icons/bread_crum_arrow.svg"
									alt="Smart Watches"
									className="w-[10px] h-[10px] ml-1"
								/>
							</div>
						</div>

						<div className="relative inline-block">
							<button
								onClick={() => setOpen(!open)}
								className="w-[122px] h-[32px] flex items-center justify-between border border-[#193D34] rounded-[24px] px-2 gap-2"
							>
								<img
									src="/assets/product/mobile/sortIconStart.svg"
									alt="start icon"
									className="w-[16px] h-[16px]"
								/>
								<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
									Sort by
								</span>
								<img
									src="/assets/product/mobile/sortIconEnd.svg"
									alt="end icon"
									className="w-[16px] h-[16px]"
								/>
							</button>

							{open && (
								<div className="absolute w-[198px] h-auto top-[40px] right-0 bg-[#E8ECEB] border border-gray-200 rounded-[4px] shadow-lg z-50">
									{sortOptions.map((option, idx) => (
										<div
											key={idx}
											className="px-4 py-2 text-[12px] text-[#193D34] font-[400] font-montserrat leading-[100%] cursor-pointer hover:bg-[#CFE6A2]"
											onClick={() => {
												console.log("Selected:", option);
												setOpen(false);
											}}
										>
											{option}
										</div>
									))}
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="flex flex-col  w-full xl:w-[90%] mx-auto h-auto   gap-[21px] hidden my-[20px] lg:flex mt-[20px] relative">
					{/* Cards container header */}
					<div className="w-full h-[52px] flex items-center justify-between">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Top Winning Dropshipping Products On{" "}
							{capitalizeFirstLetter(trendId)}
						</h1>
					</div>

					{/* Swiper container */}
					<div className="w-full relative mt-8">
						{/* Navigation Buttons */}
						<button className="custom-prev-row1 absolute left-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button className="custom-next-row1 absolute right-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={3}
							spaceBetween={32}
							navigation={{
								nextEl: ".custom-next-row1",
								prevEl: ".custom-prev-row1",
							}}
							className="w-full"
						>
							{trendDetailsCards.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="priceFilter" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
				<div className="flex flex-col  w-full xl:w-[90%] mx-auto h-auto   gap-[21px] hidden my-[20px] lg:flex mt-[20px] relative">
					{/* Cards container header */}
					<div className="w-full h-[52px] flex items-center justify-between">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Top Trending Dropshipping Products On{" "}
							{capitalizeFirstLetter(trendId)}
						</h1>
					</div>

					{/* Swiper container */}
					<div className="w-full relative">
						{/* Navigation Buttons */}
						<button className="custom-prev-row2 absolute left-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button className="custom-next-row2 absolute right-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={3}
							spaceBetween={32}
							navigation={{
								nextEl: ".custom-next-row2",
								prevEl: ".custom-prev-row2",
							}}
							className="w-full"
						>
							{trendDetailsCardsRow2.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="priceFilter" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
				<div className="flex flex-col  w-full xl:w-[90%] mx-auto h-auto   gap-[21px] hidden my-[20px] lg:flex mt-[20px] relative">
					{/* Cards container header */}
					<div className="w-full h-[52px] flex items-center justify-between">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Product With Best Customer Reviews {""}
							{capitalizeFirstLetter(trendId)}
						</h1>
					</div>

					{/* Swiper container */}
					<div className="w-full relative">
						{/* Navigation Buttons */}
						<button className="custom-prev-row3 absolute left-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button className="custom-next-row3 absolute right-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={3}
							spaceBetween={32}
							navigation={{
								nextEl: ".custom-next-row3",
								prevEl: ".custom-prev-row3",
							}}
							className="w-full"
						>
							{trendDetailsCardsRow3.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="priceFilter" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
				<div className="flex flex-col   w-full xl:w-[90%] mx-auto h-auto    gap-[21px]  hidden my-[190px] lg:flex mt-[20px]">
					<div className=" w-full xl:w-[90%] mx-auto h-[826px] left-[85px] flex flex-col gap-[16px] hidden lg:flex">
						<div className="flex flex-col gap-[10px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-black align-middle">
								Rbetraj's Automated {capitalizeFirstLetter(trendId)} Marketplace
								Dropshipping Tool
							</p>

							{/* Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								<strong>
									Find trending dropshipping products on Facebook Marketplace
								</strong>
								, as it is one of the most lucrative ways to grow your online
								store and earn profits. Facebook’s vast online resource consists
								of millions of people who could be your potential customers,
								thus enabling sellers to showcase their products and earn
								profits. Having said that, like all platforms with a vast
								database, there also come challenges to manoeuvre and thoroughly
								understand the platform's intricacies. You will have to find
								great products, understand the market trends, sift through
								customer reviews, import the chosen products, be aware of the
								dynamic pricing model and also keep track of inventory and sales
								performance. These tasks take many hours and are tiresome. With
								Rbetraj's Facebook Marketplace Dropshipping Software, you can
								take out the brunt and quickly find{" "}
								<strong>
									Winning Dropshipping products on Facebook Marketplace
								</strong>{" "}
								with a few easy clicks.
							</p>
						</div>
						<div className="flex flex-col gap-[5px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Facebook Marketplace Dropshipping Product Finder
							</p>

							{/* Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								The tool's advanced filters enable you to focus on niche
								trending products derived from advanced AI insights. The product
								finder tool quickly identifies top trending products, helps you
								import the product with one easy click, and sell them with the
								least manual intervention. Apart from that, you can also import
								or generate images and descriptions that have high potential for
								conversion.
							</p>
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Do's and Don'ts: {capitalizeFirstLetter(trendId)} Marketplace
								Dropshipping Product Research Software.
							</p>
							{/* Additional Guidelines */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black mt-2">
								Before you start dropshipping on Facebook Marketplace , you
								should familiarize yourself with the guidelines of the platform
								and keep abreast of the Do’s and Don'ts of Dropshipping on
								{capitalizeFirstLetter(trendId)} Marketplace.
							</p>

							{/* Dos */}
							<p className="font-montserrat font-semibold text-[12px] text-black mt-2">
								Dos:
							</p>
							<div className="font-montserrat text-[12px] text-black leading-[18px] space-y-2">
								<p>
									1). Thoroughly Research Trends:
									<br />
									While sourcing great products, you should research market
									trends and understand which products customers are actively
									searching for. When you use a Facebook Marketplace
									Dropshipping Finder, researching trending products becomes
									much easier and the probability of your customer buying it
									increases too.
								</p>
								<p>
									2). Leverage Dropshipping Automation Tools:
									<br />
									Automation tools are great because they take away the
									tediousness of time-consuming tasks. This is especially true
									for dropshippers. Find niche focused and trending products,
									importing them to your selling space and matching them with
									the original description and images are efficiently taken care
									of with AI tools.
								</p>
								<p>
									3). Leverage AI to Optimize Listings:
									<br />
									Generate copy with the use of AI to create descriptions that
									understand the pain points of your customers.
								</p>
							</div>

							{/* Don'ts */}
							<p className="font-montserrat font-semibold text-[12px] text-black mt-2">
								Don'ts:
							</p>
							<div className="font-montserrat text-[12px] text-black leading-[18px] space-y-2">
								<p>
									1). Avoid selling low-quality goods:
									<br />
									Before importing and selling products to customers, you want
									to ensure they are good quality. Rbetraj's Facebook
									Marketplace Dropshipping Product Finder helps you find
									products with the best customer reviews. You will not have to
									check every product for positive or negative reviews.
								</p>
								<p>
									2). Ensure you provide excellent customer service:
									<br />
									Automation is great, but let’s not forget the importance of
									after-sales support on your online store or platform.
									Responding to questions promptly and resolving issues for your
									customers will increase trust and make them come back to your
									store again.
								</p>
								<p>
									3). Keep Tabs on Price Changes:
									<br />
									This is one of the most bothersome aspects for many customers.
									When they land on the supplier's page, they notice that the
									price differs from what you have showcased in your store. Our
									real-time dynamic price change solves that problem for you.
									All prices are automatically changed according to your
									supplier's dynamic rates, ensuring consistency on all
									platforms.
								</p>
							</div>

							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Frequently Asked Questions About Facebook Marketplace
								Dropshipping Software.
							</p>

							<div className="font-montserrat font-normal text-[12px] leading-[100%] tracking-[0%] text-black space-y-4">
								<p>
									1) How am I eligible to dropship on Facebook Marketplace?
									<br />
									1. To begin with, you should have a valid Facebook account;
									your account must fulfil their eligibility requirements and
									comply with their marketplace policies.
								</p>

								<p>
									2) Is dropshipping worth it on Facebook Marketplace?
									<br />
									1.Yes, when done the right way, dropshipping can be a very
									lucrative venture on Facebook Marketplace. Use a Facebook
									Marketplace Dropshipping Automation Software that will save
									time, help you find the most sought-after products, and
									automate your workflow.
								</p>

								<p>
									3) How do I begin my dropshipping store on Facebook
									Marketplace?
									<br />
									1. To start dropshipping on Facebook Marketplace, sign up for
									an account, locate vendors that allow dropshipping, or use our
									Facebook Marketplace Dropshipping Tool to connect with top
									reliable suppliers and source the best products. Use
									automation tools to execute your business process without
									losing time.
								</p>

								<p>
									<strong>
										Get started with the Rbetraj dropshipping tool!
									</strong>{" "}
									Elevate Your Online Store with Automation with our Facebook
									Marketplace Dropshipping Tool!
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Mobile*/}
			<div className="lg:hidden w-full h-[268px] pt-4 pr-5 pb-4 pl-5 gap-4 bg-[#193D34]">
				{/* Navigation Tabs */}
				<div className="w-[378px] h-[36px] pr-5 pb-2 pl-1 gap-1 flex items-center mt-4">
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Products
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Shops
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Trends
						</span>
					</div>
				</div>

				<div className="w-[338px] h-[40px] rounded-lg border-[1.6px] border-gray-300 overflow-hidden mt-3">
					<div className="relative flex items-center w-full h-full">
						<input
							type="text"
							placeholder="Search product.."
							className="pl-4 pr-12 w-full h-full bg-white text-black placeholder:text-gray-400 outline-none focus:ring-0"
						/>
						<button className="absolute right-0 flex items-center justify-center w-[40px] h-full bg-[#B7D974] hover:bg-[#A9C864] transition-colors">
							<img
								src="/assets/home/topnav/search.png"
								alt="Search"
								className="w-[20px] h-[20px]"
							/>
						</button>
					</div>
				</div>

				<div className="lg:hidden w-[338px] flex flex-wrap items-center mt-6 gap-4">
					{/* Filter By Label */}
					<span className="font-montserrat font-normal text-[16px] leading-[32px] text-[#F6F6F6] whitespace-nowrap">
						Filter By :
					</span>

					{/* Buttons */}
					{[
						"Top Sellers",
						"Only Amazon",
						"Only Alibaba",
						"Top in Marketplace",
					].map((label, index) => (
						<button
							key={index}
							className="object-contain  h-[30px] px-[12px] py-[8px] flex items-center justify-center gap-[10px] rounded-[20px] border border-[#A7C56A] bg-[#47645D]"
						>
							<span className="whitespace-nowrap  font-montserrat font-medium text-[13px] leading-[100%] tracking-[0%] text-center text-white">
								{label}
							</span>
						</button>
					))}
				</div>
			</div>

			<div className="w-full lg:hidden flex flex-col items-center">
				{/* Icon container with background */}
				<div
					className={`w-full h-[130px] flex items-center justify-center ${bgColorClass}`}
				>
					<div className="w-[240px] h-[80px] flex items-center justify-center">
						<img
							src={`/assets/trend/xl/${trendId}.svg`}
							alt="Icon"
							className="max-w-full max-h-full object-center object-contain"
						/>
					</div>
				</div>

				{/* Text content container */}
				<div className="w-full flex items-center justify-center bg-[#E8ECEB] py-4">
					<div className="w-[378px] flex flex-col items-start text-left space-y-1">
						<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-[#193D34]">
							{`${capitalizeFirstLetter(trendId)} MarketPlace `}
						</p>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A]">
							+10,000 products listed
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A]">
							Find trending products for dropshipping among trusted and reliable
							suppliers across the globe.
						</p>
					</div>
				</div>
			</div>
			<div className="w-full lg:hidden flex items-center justify-between px-2 my-8">
				{/* Breadcrumbs */}
				<div className="flex items-center space-x-2 overflow-x-auto">
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Trends
						</span>
						<img
							src="/assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Facebook
						</span>
						<img
							src="/assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Tagsword
						</span>
						<img
							src="/assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
				</div>

				{/* Sort By Button */}
				<button className="w-[122px] h-[32px] flex items-center justify-between border border-[#193D34] rounded-[24px] px-2 gap-2">
					<img
						src="/assets/product/mobile/sortIconStart.svg"
						alt="start icon"
						className="w-[16px] h-[16px]"
					/>
					<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
						Sort by
					</span>
					<img
						src="/assets/product/mobile/sortIconEnd.svg"
						alt="end icon"
						className="w-[16px] h-[16px]"
					/>
				</button>
			</div>
			<div className="lg:hidden flex flex-col w-[100%] h-auto items-center gap-5 sm:gap-5 overflow-hidden mt-3">
				{/* Title at the top */}
				<div className="text-center text-[28px] leading-[32px] font-semibold text-[#193D34] font-[Montserrat]">
					<span className="block">Top Winning</span>
					<span className="block">Dropshipping Products</span>
					<span className="block">On Amazon</span>
				</div>

				{/* Swiper Container */}
				<div className="w-full h-[600px] flex flex-col items-center justify-center relative">
					{/* Custom Navigation Buttons */}
					<img
						src="/assets/home/section3/navigationButtonLeft.svg"
						alt="section3navNone"
						className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					<img
						src="/assets/home/section3/navigationButtonRight.svg"
						alt="section3navNone"
						className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					{/* Swiper Wrapper */}
					<div className="w-full flex justify-center">
						<Swiper
							modules={[Navigation, Pagination]}
							spaceBetween={10} // Adjusted for better spacing
							slidesPerView={1.2} // Default for small mobiles (320px)
							breakpoints={{
								481: { slidesPerView: 1.5, spaceBetween: 10 }, // Large mobiles
								768: { slidesPerView: 2.5, spaceBetween: 16 }, // Small tablets
								1024: { slidesPerView: 3.5, spaceBetween: 24 }, // Large tablets
							}}
							navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
							pagination={{
								el: ".custom-pagination",
								clickable: true,
								dynamicBullets: true,
							}}
							className="w-full"
						>
							<SwiperSlide>
								<Card variant="product_details_mobile" content={trendCardOne} />
							</SwiperSlide>
							<SwiperSlide>
								<Card variant="product_details_mobile" content={trendCardTwo} />
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={trendCardThree}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={trendCardFour}
								/>
							</SwiperSlide>
						</Swiper>
					</div>

					{/* Custom Pagination Below Swiper */}
					<div className="custom-pagination mt-4 flex justify-center w-full"></div>
				</div>
			</div>
			<div className="lg:hidden flex flex-col w-[100%] h-auto items-center gap-5 sm:gap-5 overflow-hidden mt-3">
				{/* Title at the top */}
				<div className="text-center text-[28px] leading-[32px] font-semibold text-[#193D34] font-[Montserrat]">
					<span className="block">Top Trending</span>
					<span className="block">Dropshipping Products</span>
					<span className="block">On Amazon</span>
				</div>

				{/* Swiper Container */}
				<div className="w-full h-[600px] flex flex-col items-center justify-center relative">
					{/* Custom Navigation Buttons */}
					<img
						src="/assets/home/section3/navigationButtonLeft.svg"
						alt="section3navNone"
						className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					<img
						src="/assets/home/section3/navigationButtonRight.svg"
						alt="section3navNone"
						className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					{/* Swiper Wrapper */}
					<div className="w-full flex justify-center">
						<Swiper
							modules={[Navigation, Pagination]}
							spaceBetween={10} // Adjusted for better spacing
							slidesPerView={1.2} // Default for small mobiles (320px)
							breakpoints={{
								481: { slidesPerView: 1.5, spaceBetween: 10 }, // Large mobiles
								768: { slidesPerView: 2.5, spaceBetween: 16 }, // Small tablets
								1024: { slidesPerView: 3.5, spaceBetween: 24 }, // Large tablets
							}}
							navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
							pagination={{
								el: ".custom-pagination",
								clickable: true,
								dynamicBullets: true,
							}}
							className="w-full"
						>
							<SwiperSlide>
								<Card variant="product_details_mobile" content={trendCardOne} />
							</SwiperSlide>
							<SwiperSlide>
								<Card variant="product_details_mobile" content={trendCardTwo} />
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={trendCardThree}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={trendCardFour}
								/>
							</SwiperSlide>
						</Swiper>
					</div>

					{/* Custom Pagination Below Swiper */}
					<div className="custom-pagination mt-4 flex justify-center w-full"></div>
				</div>
			</div>
			<div className="lg:hidden flex flex-col w-[100%] h-auto items-center gap-5 sm:gap-5 overflow-hidden mt-3">
				{/* Title at the top */}
				<div className="text-center text-[28px] leading-[32px] font-semibold text-[#193D34] font-[Montserrat]">
					<span className="block">Product With</span>
					<span className="block">Best Customer</span>
					<span className="block">Review</span>
				</div>

				{/* Swiper Container */}
				<div className="w-full h-[600px] flex flex-col items-center justify-center relative">
					{/* Custom Navigation Buttons */}
					<img
						src="/assets/home/section3/navigationButtonLeft.svg"
						alt="section3navNone"
						className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					<img
						src="/assets/home/section3/navigationButtonRight.svg"
						alt="section3navNone"
						className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					{/* Swiper Wrapper */}
					<div className="w-full flex justify-center">
						<Swiper
							modules={[Navigation, Pagination]}
							spaceBetween={10} // Adjusted for better spacing
							slidesPerView={1.2} // Default for small mobiles (320px)
							breakpoints={{
								481: { slidesPerView: 1.5, spaceBetween: 10 }, // Large mobiles
								768: { slidesPerView: 2.5, spaceBetween: 16 }, // Small tablets
								1024: { slidesPerView: 3.5, spaceBetween: 24 }, // Large tablets
							}}
							navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
							pagination={{
								el: ".custom-pagination",
								clickable: true,
								dynamicBullets: true,
							}}
							className="w-full"
						>
							<SwiperSlide>
								<Card variant="product_details_mobile" content={trendCardOne} />
							</SwiperSlide>
							<SwiperSlide>
								<Card variant="product_details_mobile" content={trendCardTwo} />
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={trendCardThree}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={trendCardFour}
								/>
							</SwiperSlide>
						</Swiper>
					</div>

					{/* Custom Pagination Below Swiper */}
					<div className="custom-pagination mt-4 flex justify-center w-full"></div>
				</div>
			</div>
			{/* Mobile Friendly Version */}
			<div className="flex flex-col w-full px-4 gap-5 my-5 lg:hidden">
				<div className="flex flex-col gap-4">
					{/* Heading */}
					<p className="font-montserrat font-bold text-[16px] text-black">
						Rbetraj's Automated {capitalizeFirstLetter(trendId)} Marketplace
						Dropshipping Tool
					</p>

					{/* Description */}
					<p className="font-montserrat text-[12px] text-black leading-[18px]">
						Find trending dropshipping products on Facebook Marketplace, one of
						the most lucrative platforms to grow your online store and earn
						profits. Facebook’s vast audience offers sellers the opportunity to
						showcase their products to millions of potential buyers. However,
						success requires effort—finding great products, tracking trends,
						reading reviews, importing products, managing pricing, and
						monitoring inventory and sales. These tasks are time-consuming. With
						Rbetraj’s Facebook Marketplace Dropshipping Software, you can
						simplify your workflow and find winning dropshipping products in
						just a few clicks.
					</p>

					{/* Subsection Heading */}
					<p className="font-montserrat font-semibold text-[13px] text-black">
						Facebook Marketplace Dropshipping Product Finder
					</p>
					<p className="font-montserrat text-[12px] text-black leading-[18px]">
						Use advanced filters and AI-powered insights to find niche trending
						products quickly. The tool helps you import products with one click,
						along with optimized images and high-converting descriptions.
					</p>

					{/* Subsection Heading */}
					<p className="font-montserrat font-semibold text-[13px] text-black">
						Do's and Don'ts: {capitalizeFirstLetter(trendId)} Marketplace
						Dropshipping Product Research Software
					</p>
					<p className="font-montserrat text-[12px] text-black leading-[18px] mt-2">
						Familiarize yourself with the platform guidelines before starting.
						Here's what to follow and what to avoid:
					</p>

					{/* Do's */}
					<p className="font-montserrat font-semibold text-[12px] text-black mt-2">
						Dos:
					</p>
					<div className="font-montserrat text-[12px] text-black leading-[18px] space-y-2 pl-2">
						<p>
							1). Thoroughly research trends. Understand what products are
							currently in demand using tools to boost chances of success.
						</p>
						<p>
							2). Leverage dropshipping automation tools to eliminate repetitive
							tasks like importing, image matching, and description editing.
						</p>
						<p>
							3). Use AI to generate optimized product descriptions that
							highlight customer pain points and benefits.
						</p>
					</div>

					{/* Don'ts */}
					<p className="font-montserrat font-semibold text-[12px] text-black mt-2">
						Don'ts:
					</p>
					<div className="font-montserrat text-[12px] text-black leading-[18px] space-y-2 pl-2">
						<p>
							1). Avoid selling low-quality goods. Always check reviews and
							ratings. Let Rbetraj help you find top-rated products.
						</p>
						<p>
							2). Don’t neglect customer service. Promptly respond to customer
							queries and resolve issues to build trust and loyalty.
						</p>
						<p>
							3). Keep tabs on price changes. Inconsistent pricing between your
							store and suppliers can frustrate customers. Let Rbetraj
							auto-adjust prices in real-time.
						</p>
					</div>

					{/* FAQs */}
					<p className="font-montserrat font-semibold text-[13px] text-black mt-4">
						Frequently Asked Questions About Facebook Marketplace Dropshipping
						Software
					</p>
					<div className="font-montserrat text-[12px] text-black leading-[18px] space-y-4 mt-2">
						<p>
							1) How am I eligible to dropship on Facebook Marketplace?
							<br />– You must have a valid Facebook account that complies with
							their marketplace policies.
						</p>
						<p>
							2) Is dropshipping worth it on Facebook Marketplace?
							<br />– Yes, when executed properly with automation tools like
							Rbetraj, it can save time and generate profits.
						</p>
						<p>
							3) How do I start?
							<br />– Create a Facebook account, find reliable dropshipping
							vendors, or use Rbetraj’s software to connect with suppliers and
							begin selling.
						</p>
						<p>
							Get started with the Rbetraj dropshipping tool. Elevate your
							online store with automation and stay ahead of the competition!
						</p>
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default TrendDetails;
